<template>
  <div>
    <v-sheet class="py-6 py-md-8 px-3" color="primary">
      <TitleWidget :small="xsOnly" dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <v-container class="pt-6 pt-md-8 pb-10 pb-md-13 pb-lg-16">
      <LoadingWidget v-if="loading" />

      <div v-else-if="items.length">
        <div
          class="team-wrapper"
          v-for="(category, keyItems) in categories"
          :key="keyItems"
        >
          <TitleWidget>{{ category.title }}</TitleWidget>
          <TeamSection :category="category.id"></TeamSection>
        </div>
      </div>

      <v-alert v-else type="info">{{ noContentText }}</v-alert>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TeamSection from "../components/sections/TeamSection.vue";

const _config = {
  mod: "management-team",
};

const _data = {
  title: "Equipe de apoio",
  loading: true,
  noContentText: "Nenhum conteúdo adicionado até o momento, volte mais tarde.",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    categories() {
      return Object.values(
        this.$rest(_config.mod).list.reduce((acc, item) => {
          const { id, title } = item.category;
          if (!acc[id]) {
            acc[id] = { id, title };
          }
          return acc;
        }, {})
      );
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getList() {
      this.loading = true;

      this.$rest(_config.mod)
        .get()
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  components: {
    TitleWidget,
    LoadingWidget,
    TeamSection,
  },
};
</script>
